(() => {
  const source = document.currentScript;
  const section = source?.closest('.shopify-section') || source?.parentElement;
  const slider = section?.querySelector('.slideshow__swiper');
  const slideCount = slider?.querySelectorAll('.swiper-slide').length || 0;

  if (!slider || slideCount <= 1) {
    slider?.classList.add('slideshow__swiper--static');
    return;
  }

  const load = () =>
    window
      .loadSwiperRuntime('slideshow-runtime.js', source)
      .catch((error) => console.error('No fue posible cargar slideshow.', error));

  if (window.loadSwiperRuntime) load();
  else window.addEventListener('theme:swiper-loader:ready', load, { once: true });
})();
